require('../assets/qwiet-calculator.scss');
require('../assets/qwiet-calculator.js');